import type { AppRegistryPage } from '@plato/app-meta/ai-meta';
import { usePageAiMeta } from '@plato/app-shared/hooks/use-page-ai-meta';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '../../components/page-title.tsx';
import { useDraftListColumns } from '../../features/sales-draft-list/hooks/use-draft-list-columns.tsx';
import { DraftListPage } from '../../features/sales-draft-list/pages/drafts-list-page.tsx';

export function useDraftListAiMeta(): AppRegistryPage {
    const { t } = useTranslation();
    return usePageAiMeta(
        {
            path: '/drafts',
            title: t('page_title__sales_drafts', { ns: 'common' }),
            requiresTransactionDrafts: true,
            description:
                'All quotes and orders that users prepare in Plato before they go to the ERP, ' +
                'filterable by customer and creator. New drafts start here. Documents already in the ' +
                'ERP live on the orders and quotes pages. Drafts appear in Rep view; a manager reaches ' +
                'them by switching to Rep view. Some tenants do not have this page; if the user cannot ' +
                'see it, it is not enabled for them.',
        },
        useDraftListColumns(),
    );
}

function Drafts() {
    const { t } = useTranslation();

    return (
        <>
            <PageTitle title={t('page_title__sales_drafts')} />
            <DraftListPage />
        </>
    );
}

export default Drafts;
